import {history} from '../store/configureStore';
import {pathnames as P} from '../constants/pathnames';

export const checkNextStepAndGo = nextStep => {
  if (nextStep > 0) history.push(P.GET_STEP_PATH(nextStep))
};
